var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main" }, [
    _c("footer", [
      _c("div", { staticClass: "footer_left" }, [
        _c("img", { attrs: { src: _vm.gameData.logoImage, alt: "" } }),
        _c("p", [_vm._v(_vm._s(_vm.gameData.footer))]),
        _c("p", [
          _vm._v(
            "Trademarks belong to their respective owners. All rights reserved."
          ),
        ]),
        _vm.gameData.gameCode === "fzsgkr"
          ? _c("p", [_vm._v("연락처：chenqiyi@wanxinbuzhi.com")])
          : _vm._e(),
      ]),
      _c("div", { staticClass: "footer_right" }, [
        _c(
          "a",
          {
            staticStyle: { color: "#BFBFBF" },
            on: {
              click: function ($event) {
                return _vm.openRouteInNewWindow("archive")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("service_terms_text")))]
        ),
        _c("span", { staticStyle: { color: "#BFBFBF" } }, [_vm._v(" | ")]),
        _c(
          "a",
          {
            staticStyle: { color: "#BFBFBF" },
            on: {
              click: function ($event) {
                return _vm.openRouteInNewWindow("privacy")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("privacy_policy_text")))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }